import {
  EUDR_DETECTION_FEATURE,
  eudrDetectionFeature,
} from '@xbcb/feature-flags';
import { uiStageToBackendStage } from '@xbcb/ui-types';
import { getEnv } from '@xbcb/ui-utils';

export const isEudrDetectionEnabled = (): boolean =>
  EUDR_DETECTION_FEATURE.isEnabled(eudrDetectionFeature, {
    stage: uiStageToBackendStage[getEnv().stage],
  });
